import { ContestTaskRenderer } from '../utils/ContestTaskRenderer.js';

export default class ContestTaskLeaderboardMap {

    constructor() {
        this.contest_task_id = 0;
        this.track_ids = [];
        this.contest_task_geojson = null;
        this.map = null;
        this.paths = [];
        this.renderer = null;
        this.originalMapHeight = null;
        this.taskRendered = false;
        this.tracksRendered = false;
        this.currentTrackId = null; // Track currently being displayed solo
        this.isDragging = false;
        this.dragStartX = 0;
        this.dragStartY = 0;
        this.containerStartX = 0;
        this.containerStartY = 0;
        this.dragHandleInitialized = false;

        this.bindEvents();
        this.initMap();

        // Initialize drag after DOM is ready
        const self = this;
        setTimeout(() => {
            self.checkAndInitDrag();
        }, 500);

        // Handle window resize
        window.addEventListener('resize', () => {
            self.handleResize();
        });
    }

    bindEvents(){
        let self = this;

        // Handle track toggle button clicks
        $(document).on('click', '.track-toggle-btn', function(e) {
            e.preventDefault();
            const trackId = $(this).data('track-id');
            self.toggleTrackDisplay(trackId, $(this));
        });
    }

    onDataChanged(data) {
        this.contest_task_id = data.contest_task_id;
        this.track_ids = data.track_ids;
        this.contest_task_geojson = data.contest_task_geojson;

        this.drawContestTask();
        this.loadTrackPoints();
    }


    onDestroy(){
        this.map.remove();
    }

    initMap() {
        // Check if we're on mobile (floating widget) or desktop
        const isMobile = window.innerWidth < 992;

        let height;
        if (isMobile) {
            // On mobile, the height is set by CSS (50vh for floating widget)
            height = window.innerHeight * 0.5;
        } else {
            // On desktop, calculate based on parent container
            height = $("#leaderboard-map").parent().height();
            if(height<400){
                height = 400;
            }
            $("#leaderboard-map").height(height);
        }

        // Store the original height for restoring after fullscreen
        this.originalMapHeight = height;

        this.map = L.map('leaderboard-map', {
            attributionControl: false
        }).setView([41.831131, 15.624207], 2);

        L.tileLayer('https://tile.tracestrack.com/_/{z}/{x}/{y}.png?key=5b37c4cf109fa26755308c3a5e221369'
        ).addTo(this.map);

        // Initialize the renderer
        this.renderer = new ContestTaskRenderer(this.map);

        // Add fullscreen button
        this.addFullscreenButton();

        // Invalidate map size after a short delay to ensure proper rendering
        setTimeout(() => {
            this.map.invalidateSize();
        }, 100);
    }

    addFullscreenButton() {
        const full_screen_btn = L.easyButton(
            '<span class="fs-18 mt-1 text-gray ff-lato" id="full-toggle" data-toggle="tooltip" data-placement="bottom" title="' +
                I18n.t("website.home.index.full_screen") +
                '"><i id="full-icon" class="fas fa-expand"></i></span>',
            () => {
                if (
                    document.fullscreenElement ||
                    document.webkitFullscreenElement ||
                    document.mozFullScreenElement ||
                    document.msFullscreenElement
                ) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    let element = $("#leaderboard-container").get(0);
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.webkitRequestFullscreen) {
                        element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                    } else if (element.msRequestFullscreen) {
                        element.msRequestFullscreen();
                    }
                }
            }
        );

        full_screen_btn.addTo(this.map);

        // Listen for fullscreen changes to resize the map
        const onFullscreenChange = () => {
            setTimeout(() => {
                if (
                    document.fullscreenElement ||
                    document.webkitFullscreenElement ||
                    document.mozFullScreenElement ||
                    document.msFullscreenElement
                ) {
                    // Entering fullscreen - set map to 100vh
                    $("#leaderboard-map").height('100vh');
                } else {
                    // Exiting fullscreen - restore original height
                    $("#leaderboard-map").height(this.originalMapHeight);
                }
                this.map.invalidateSize();

                // Re-fit bounds to use all available space
                this.fitBoundsIfReady();
            }, 100);
        };

        document.addEventListener('fullscreenchange', onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', onFullscreenChange);
        document.addEventListener('mozfullscreenchange', onFullscreenChange);
        document.addEventListener('MSFullscreenChange', onFullscreenChange);
    }

    drawContestTask() {
        // Use the renderer to load and display the contest task
        // Don't fit bounds yet - wait for tracks to load
        this.renderer.renderFromAPI(this.contest_task_id, () => {
            // Callback is executed after task is rendered
            this.taskRendered = true;
            this.fitBoundsIfReady();
        });
    }

    loadTrackPoints() {
        let self = this;

        let ajaxData = {
            url: window.application.getAPIUrl() + "/v1/contest_task/" + this.contest_task_id + "/leaderboard_tracks_points",
            data: {},
            method: "get",
            beforeSend: function(request) {
                request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
            },
        };
        $.ajax(ajaxData).done(function(data) {
            if (data !== undefined){
                self.drawPath(data);
            }
        }).fail(function() {
        });

    }

    loadSingleTrackPoints(trackId) {
        let self = this;

        let ajaxData = {
            url: window.application.getAPIUrl() + "/v1/contest_task/" + this.contest_task_id + "/leaderboard_tracks_points",
            data: { track_id: trackId },
            method: "get",
            beforeSend: function(request) {
                request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
            },
        };
        $.ajax(ajaxData).done(function(data) {
            if (data !== undefined){
                self.drawPath(data, true); // true indicates single track highlight
            }
        }).fail(function() {
        });
    }

    clearPaths() {
        // Remove all paths from the map
        this.paths.forEach(function(path) {
            path.remove();
        });
        this.paths = [];
        this.tracksRendered = false;
    }

    toggleTrackDisplay(trackId, buttonElement) {
        // Remove active state from all buttons
        $('.track-toggle-btn').removeClass('active');

        if (this.currentTrackId === trackId) {
            // Clicking the same track again - restore all tracks
            this.currentTrackId = null;
            this.clearPaths();
            this.loadTrackPoints();
        } else {
            // Show only this track
            this.currentTrackId = trackId;
            this.clearPaths();
            this.loadSingleTrackPoints(trackId);

            // Highlight the button
            buttonElement.addClass('active');
        }
    }

    centerView(latlong, zoom = null, duration = 3) {
        this.map.setView(latlong, zoom, {
            "animate": true,
            "pan": {
                "duration": duration,
                easeLinearity: 1
            }
        });
    }

    drawPath(paths, highlightSingle = false) {
        let self = this;
        paths.forEach(function (item) {
            var color = "rgb("+item["color"][0]+" ,"+item["color"][1]+","+ item["color"][2]+")";

            if (highlightSingle) {
                const r = item["color"][0] / 255;
                const g = item["color"][1] / 255;
                const b = item["color"][2] / 255;
                const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

                const strokeColor = luminance > 0.5 ? 'black' : 'white';

                const contrastStroke = L.polyline(item.points, {
                    color: strokeColor,
                    weight: 4,
                    opacity: 0.8
                }).addTo(self.map);
                self.paths.push(contrastStroke);
            }

            const colorLine = L.polyline(item.points, {color: color, weight: 2}).addTo(self.map);

            self.paths.push(colorLine);
        });

        this.tracksRendered = true;
        this.fitBoundsIfReady();
    }

    fitBoundsIfReady() {
        // Only fit bounds once both task and tracks are rendered
        if (!this.taskRendered || !this.tracksRendered) {
            return;
        }

        const allLayers = [];

        // Add task layers from renderer (waypoints only, not tracks)
        if (this.renderer && this.renderer.taskLayers) {
            allLayers.push(...this.renderer.taskLayers);
        }

        // Create a feature group and fit bounds on waypoints only
        if (allLayers.length > 0) {
            const group = L.featureGroup(allLayers);
            this.map.fitBounds(group.getBounds(), {
                padding: [0, 0]
            });
        }
    }

    initDrag() {
        // Only enable dragging on mobile
        if (window.innerWidth >= 992) {
            return;
        }

        const container = document.getElementById('leaderboard-container');
        if (!container) {
            return;
        }

        // Check if drag handle already exists
        let dragHandle = container.querySelector('.leaderboard-drag-handle');
        if (dragHandle) {
            return; // Already initialized
        }

        const self = this;

        // Create drag handle
        dragHandle = document.createElement('div');
        dragHandle.className = 'leaderboard-drag-handle';
        container.insertBefore(dragHandle, container.firstChild);

        // Mouse events
        dragHandle.addEventListener('mousedown', function(e) {
            e.preventDefault();
            self.startDrag(e.clientX, e.clientY);
        });

        // Touch events
        dragHandle.addEventListener('touchstart', function(e) {
            e.preventDefault();
            const touch = e.touches[0];
            self.startDrag(touch.clientX, touch.clientY);
        });

        // Mouse move
        document.addEventListener('mousemove', function(e) {
            if (self.isDragging) {
                self.doDrag(e.clientX, e.clientY);
            }
        });

        // Touch move
        document.addEventListener('touchmove', function(e) {
            if (self.isDragging) {
                e.preventDefault();
                const touch = e.touches[0];
                self.doDrag(touch.clientX, touch.clientY);
            }
        }, { passive: false });

        // Mouse/touch end
        document.addEventListener('mouseup', function() {
            if (self.isDragging) {
                self.stopDrag();
            }
        });

        document.addEventListener('touchend', function() {
            if (self.isDragging) {
                self.stopDrag();
            }
        });
    }

    startDrag(clientX, clientY) {
        this.isDragging = true;
        this.dragStartX = clientX;
        this.dragStartY = clientY;

        const container = document.getElementById('leaderboard-container');
        const rect = container.getBoundingClientRect();

        // Store current position (converting from bottom/right to top/left for easier calculation)
        this.containerStartX = rect.left;
        this.containerStartY = rect.top;

        document.body.style.cursor = 'grabbing';
    }

    doDrag(clientX, clientY) {
        const container = document.getElementById('leaderboard-container');
        if (!container) return;

        const deltaX = clientX - this.dragStartX;
        const deltaY = clientY - this.dragStartY;

        const newX = this.containerStartX + deltaX;
        const newY = this.containerStartY + deltaY;

        // Allow dragging outside viewport, but keep drag handle visible
        const rect = container.getBoundingClientRect();
        const dragHandleHeight = 30; // Height of the drag handle

        // Only constrain to keep the drag handle visible
        const minX = -(rect.width - 50); // Allow moving almost completely off-screen to the left
        const maxX = window.innerWidth - 50; // Allow moving almost completely off-screen to the right
        const minY = 0; // Keep top visible
        const maxY = window.innerHeight - dragHandleHeight; // Keep drag handle visible at bottom

        const constrainedX = Math.max(minX, Math.min(maxX, newX));
        const constrainedY = Math.max(minY, Math.min(maxY, newY));

        // Set position
        container.style.left = constrainedX + 'px';
        container.style.top = constrainedY + 'px';
        container.style.right = 'auto';
        container.style.bottom = 'auto';
    }

    stopDrag() {
        this.isDragging = false;
        document.body.style.cursor = '';
    }

    checkAndInitDrag() {
        const isMobile = window.innerWidth < 992;

        if (isMobile && !this.dragHandleInitialized) {
            this.initDrag();
            this.dragHandleInitialized = true;
        } else if (!isMobile && this.dragHandleInitialized) {
            this.removeDragHandle();
            this.dragHandleInitialized = false;
        }
    }

    removeDragHandle() {
        const container = document.getElementById('leaderboard-container');
        if (!container) return;

        const dragHandle = container.querySelector('.leaderboard-drag-handle');
        if (dragHandle) {
            dragHandle.remove();
        }

        // Reset container positioning for desktop
        container.style.left = '';
        container.style.top = '';
        container.style.right = '';
        container.style.bottom = '';
    }

    handleResize() {
        const isMobile = window.innerWidth < 992;
        const container = document.getElementById('leaderboard-container');

        if (!container) return;

        if (isMobile && !this.dragHandleInitialized) {
            // Switching from desktop to mobile
            this.checkAndInitDrag();
            // Reset position to default bottom-right
            container.style.left = '';
            container.style.top = '';
            container.style.right = '20px';
            container.style.bottom = '20px';
        } else if (!isMobile && this.dragHandleInitialized) {
            // Switching from mobile to desktop
            this.checkAndInitDrag();
        }

        // Invalidate map size to adjust to new container dimensions
        if (this.map) {
            setTimeout(() => {
                this.map.invalidateSize();
            }, 100);
        }
    }

}
